// extracted by mini-css-extract-plugin
module.exports = {"section_home":"Home_section_home__3Owd3","logo":"Home_logo__HI7OG","wrapper":"Home_wrapper__rLeS_","logoWrapper":"Home_logoWrapper__2vCNB","header":"Home_header__1fiuq"};